import { useTourEventState } from '@containers/Home/global/TourStats';
import dynamic from 'next/dynamic';
import React, { memo, useCallback } from 'react';

const DialogPost = dynamic(() => import('@components/DialogPost'));

const PostScene = memo(() => {
  const [tourEventState, setTourEventState] = useTourEventState('state');

  const onCloseDialogPostScene = useCallback(() => {
    setTourEventState(prev => ({
      ...prev,
      idPostSceneSelected: '',
      visibleDialogPostScene: false,
    }));
  }, [setTourEventState]);

  return (
    <DialogPost
      onCancel={onCloseDialogPostScene}
      isUseDefaultStyle={false}
      idPost={tourEventState.idPostSceneSelected}
      visible={tourEventState.visibleDialogPostScene}
    />
  );
});

export default PostScene;
